const awardsData = [
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Best high-end Residential'],
    rightDetail: 'The Rubik',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Best high-end Residential'],
    rightDetail: 'Ellipse Waterfall',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Best Interiors'],
    rightDetail: 'Grand Hotel',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Best mixed-use development'],
    rightDetail: 'Old Cape Quarter',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Best mixed-use development'],
    rightDetail: 'Conradie Park',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['API Awards Finalist', 'Woman in Real Estate'],
    rightDetail: 'Renske Haller, dhk MD',
    image: require('../../../assets/images/awardsimage1.webp'),
  },
  {
    year: '2024',
    leftDetails: ['Scape Awards Finalist', 'Hospitality Build of the Year'],
    rightDetail: 'Radisson Red',
    image: require('../../../assets/images/awardsimage2.webp'),
  },
  {
    year: '2024',
    leftDetails: ['Scape Awards Finalist', 'Collaboration of the Year'],
    rightDetail: 'Conradie Parks',
    image: require('../../../assets/images/awardsimage2.webp'),
  },
  {
    year: '2024',
    leftDetails: ['Scape Awards Finalist', 'Architectural Firm of the Year'],
    rightDetail: 'dhk architects',
    image: require('../../../assets/images/awardsimage2.webp'),
  },
  {
    year: '2023',
    leftDetails: ['CIfA Winner', 'Award for Architecture'],
    rightDetail: 'Old Cape Quarter',
    image: require('../../../assets/images/awardsimage3.webp'),
  },
  {
    year: '2023',
    leftDetails: ['CIfA Winner', 'Commendation for Architecture'],
    rightDetail: '35 Lower Long',
    image: require('../../../assets/images/awardsimage3.webp'),
  },
  {
    year: '2023',
    leftDetails: ['CIfA Winner', 'Award for Architecture'],
    rightDetail: 'Conradie Park Social Housing',
    image: require('../../../assets/images/awardsimage3.webp'),
  },
  {
    year: '2023',
    leftDetails: ['Gauteng Institute for Architecture Award Winner', 'Award of Excellence'],
    rightDetail: 'Radisson Red',
    image: require('../../../assets/images/awardsimage4.webp'),
  },
  {
    year: '',
    leftDetails: ['Gauteng Institute for Architecture Award Winner', 'Architecture Award of Merit'],
    rightDetail: '',
    image: require('../../../assets/images/awardsimage4.webp'),
  },
  {
    year: '2023',
    leftDetails: ['Gauteng Institute for Architecture Award Winner', 'Award of Merit'],
    rightDetail: 'Old Oak at Royal Johannesburg',
    image: require('../../../assets/images/awardsimage4.webp'),
  },
  {
    year: '2023',
    leftDetails: ['Gauteng Institute for Architecture Award Winner', 'Award of Commendation'],
    rightDetail: 'Arup, 6 Parks Boulevard',
    image: require('../../../assets/images/awardsimage4.webp'),
  },
  {
    year: '2023',
    leftDetails: ['SAPOA Award for innovative Excellence Winner', 'Innovative Excellence'],
    rightDetail: 'Ellipse Waterfall',
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2022',
    leftDetails: ['Construction World Winner', 'The Best Project'],
    rightDetail: 'Old Cape Quarter',
    image: require('../../../assets/images/awardsimage6.webp'),
  },
  {
    year: '2022',
    leftDetails: ['Reside Property Development Award Winner', 'Residential Development of the Year'],
    rightDetail: 'Conradie Parks',
    image: require('../../../assets/images/awardsimage7.webp'),
  },
  {
    year: '2022',
    leftDetails: ['SAPOA Award for Innovative Excellence Winner', 'Best Commercial Office Development'],
    rightDetail: '35 Lower Long',
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ['SAPOA Award for Innovative Excellence Winner', 'Overall Heritage'],
    rightDetail: '',
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2021',
    leftDetails: ['SAPOA Award for Innovative Excellence Winner', 'Overall Heritage'],
    rightDetail: '32 on Kloof',
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2021',
    leftDetails: ['SAPOA Award for Innovative Excellence Winner', 'Other Developments'],
    rightDetail: 'Parklands College "Innovation and Learning Centre',
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2020',
    leftDetails: ['Architizer A+ Award Winner', 'Concepts - Plus-Architecture +Preservation'],
    rightDetail: '32 on Kloof',
    image: require('../../../assets/images/awardsimage8.webp'),
  },
  {
    year: '2020',
    leftDetails: ["Conde Nast Traveler: Reader's Choice Award Winner", 'Best Hotels in Africa'],
    rightDetail: "Delaire Graff Owner's Villa and Lodges",
    image: require('../../../assets/images/awardsimage9.webp'),
  },
  {
    year: '2020',
    leftDetails: ["Construction World's Best Projects Award Winner", 'Highly Commended'],
    rightDetail: "Capitec Bank HQ",
    image: require('../../../assets/images/awardsimage6.webp'),
  },
  {
    year: '2019',
    leftDetails: ["A' Bronze Design Award", 'Architecture'],
    rightDetail: "Sable Park",
    image: require('../../../assets/images/awardsimage10.webp'),
  },
  {
    year: '2019',
    leftDetails: ["A' Bronze Design Award Winner", 'Award'],
    rightDetail: "Axis",
    image: require('../../../assets/images/awardsimage10.webp'),
  },
  {
    year: '2019',
    leftDetails: ["A' Bronze Design Award Winner", 'Architecture Award'],
    rightDetail: "Norval Foundation",
    image: require('../../../assets/images/awardsimage10.webp'),
  },
  {
    year: '2019',
    leftDetails: ["A' Bronze Design Award Winner", 'Landscape Design'],
    rightDetail: "Battery Park",
    image: require('../../../assets/images/awardsimage10.webp'),
  },
  {
    year: '',
    leftDetails: ["Architizer A+ Award Finalist", 'Concepts - Plus-Architecture + Urban Transformation'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage8.webp'),
  },
  {
    year: '',
    leftDetails: ["Architizer A+ Special Mention", 'Details - Plus-Architecture + Cantilever'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage8.webp'),
  },
  {
    year: '',
    leftDetails: ["Fulton Award Winner", 'Innovation in Concrete'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage11.webp'),
  },
  {
    year: '',
    leftDetails: ["Fulton Award Winner", 'Buildings Greater than 3-Storeys'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage11.webp'),
  },
  {
    year: '',
    leftDetails: ["Loerie Award Winner", 'Silver'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage12.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Overall Heritage'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Office Developments Commercial'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Other Developments'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2017',
    leftDetails: ["CIfA Award Winner", 'Commendation'],
    rightDetail: "Waterway House",
    image: require('../../../assets/images/awardsimage13.webp'),
  },
  {
    year: '2016',
    leftDetails: ["International Property Awards Winner", 'Highly Commended Development'],
    rightDetail: "Paardevlei Lifestyle Estate",
    image: require('../../../assets/images/awardsimage14.webp'),
  },
  {
    year: '2016',
    leftDetails: ["SACSC Retail Design + Development Award Winner", 'Shopping centers less than 20,000 meters-squared'],
    rightDetail: "Dainfern Square",
    image: require('../../../assets/images/awardsimage15.webp'),
  },
  {
    year: '2015',
    leftDetails: ["Eastern Cape Institute of Architects Award Winner", 'Regional'],
    rightDetail: "Drostdy Hotel",
    image: require('../../../assets/images/awardsimage16.webp'),
  },
  {
    year: '2015',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Overall Winner'],
    rightDetail: "Newtown Junction",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Heritage'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Transformation'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Mixed-use'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2014',
    leftDetails: ["International Property Awards Winner", 'Residential Development'],
    rightDetail: "De Velde",
    image: require('../../../assets/images/awardsimage14.webp'),
  },
  {
    year: '2012',
    leftDetails: ["SAIA Awards for Excellence Winner", 'Public + Education'],
    rightDetail: "UWC Life Sciences Building",
    image: require('../../../assets/images/awardsimage17.webp'),
  },
  {
    year: '2011',
    leftDetails: ["CIfA Award Winner", 'Architecture'],
    rightDetail: "UWC Life Sciences Building",
    image: require('../../../assets/images/awardsimage13.webp'),
  },
  {
    year: '2011',
    leftDetails: ["SAPOA Award for Innovative Excellence Commendation", 'Other Category'],
    rightDetail: "Taj Palace Hotel",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Other Development'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2010',
    leftDetails: ["High Commendation - Leisure + Hospitality", 'Architecture'],
    rightDetail: "15 on Orange",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2010',
    leftDetails: ["SAPOA Award For Innovative Excellence Merit", 'Mixed-use'],
    rightDetail: "Melrose Arch Piazza",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2010',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Commercial'],
    rightDetail: "Boulevard Office Park",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '',
    leftDetails: ["SAPOA Award for Innovative Excellence Winner", 'Mixed-use'],
    rightDetail: "",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2009',
    leftDetails: ["Retail Design + Development Award Winner", '25000sqm'],
    rightDetail: "Melrose Arch Piazza",
    image: require('../../../assets/images/awardsimage15.webp'),
  },
  {
    year: '2009',
    leftDetails: ["SAPOA Award For Innovative Excellence Merit", 'International Development'],
    rightDetail: "Ahmed Baba Institute",
    image: require('../../../assets/images/awardsimage5.webp'),
  },
  {
    year: '2009',
    leftDetails: ["Steel Tube & Pipe Manufacturers Steel Award Winner", 'for Tubular Structures'],
    rightDetail: "Melrose Arch, Galleria Roof",
    image: require('../../../assets/images/awardsimage18.webp'),
  },
  {
    year: '2007',
    leftDetails: ["Architecture South Africa Project Award Winner", 'Outstanding Design in Architecture'],
    rightDetail: "Ahmed Baba Institute",
    image: require('../../../assets/images/awardsimage17.webp'),
  },
  {
    year: '2006',
    leftDetails: ["SAIA Merit Award Winner", ''],
    rightDetail: "UCT Chemical Engineering Building",
    image: require('../../../assets/images/awardsimage17.webp'),
  },
  {
    year: '2006',
    leftDetails: ["SAIA Merit Award Winner", ''],
    rightDetail: "CTICC",
    image: require('../../../assets/images/awardsimage17.webp'),
  },
  {
    year: '2005',
    leftDetails: ["SAIA Merit Award Winner", 'Commendation'],
    rightDetail: "UCT Engineering Building",
    image: require('../../../assets/images/awardsimage13.webp'),
  },
  {
    year: '2005',
    leftDetails: ["SAIA Merit Award Winner", ''],
    rightDetail: "CTICC",
    image: require('../../../assets/images/awardsimage13.webp'),
  },
];

export default awardsData;
